import React, { createContext, useContext, useMemo, useState } from 'react';
import { copy, Lang, Copy } from '../data/content';
interface LanguageValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggle: () => void;
  t: Copy;
}
const LanguageContext = createContext<LanguageValue | null>(null);
export function LanguageProvider({
  children,
  initialLang = 'en'
}: {
  children: React.ReactNode;
  initialLang?: Lang;
}) {
  const [lang, setLang] = useState<Lang>(initialLang);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    setLang,
    toggle: () => setLang(prev => prev === 'en' ? 'es' : 'en'),
    t: copy[lang]
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-430" data-mp="1392t7f9fgnqu">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
}